module.exports = {
  ...require(`../../firebase-config.production`),
  appId: '1:104679062824:web:5a7432b3194454a5',
  measurementId: 'G-VV2ZL29Y4D',
};
